import {useRef, useState, useContext, useEffect} from 'react'
import MapGL, {MapContext} from '@goongmaps/goong-map-react'
import Geocoder from '@goongmaps/goong-geocoder-react'
import {KTSVG} from '../../_metronic/helpers'

function CustomMarker(props) {
  const context = useContext(MapContext);
  
  const {longitude, latitude} = props;

  const [x, y] = context.viewport.project([longitude, latitude]);

  const markerStyle = {
    position: 'absolute',
    left: x,
    top: y
  };

  return (
    <div style={markerStyle} >
      <KTSVG
        className='svg-icon-2x ms-n1 svg-marker-map'
        path='/media/icons/duotune/general/gen018.svg'
      />
    </div>
  );
}

const MapCustom = ({handleGetAddress, longitudeDefault, latitudeDefault}) => {
  const [viewPort, setViewport] = useState({
    latitude: 21.026975,
    longitude: 105.85346,
    zoom: 12,
  })
  const [markPosition, setMarkPosition] = useState({
    latitude: latitudeDefault ? latitudeDefault : 21.026975,
    longitude: longitudeDefault ? longitudeDefault : 105.85346,
  })
  const [inputValue, setInputValue] = useState('')
  const mapRef = useRef()

  const handleViewportChange = (viewport) => {
    setViewport((preState) => {
      return { ...preState, ...viewport }
    })
  }

  const handleGeocoderViewportChange = (viewport) => {
    const geocoderDefaultOverrides = { transitionDuration: 1000 }
    viewport.zoom = 16
    return handleViewportChange({
      ...viewport,
      ...geocoderDefaultOverrides
    })
  }

  const handleGetResult = (e) => {
    if(e && e?.result) {
      // giá trị của result: tìm 273 Đội Cấn
      // compound: {district: 'Ba Đình', commune: 'Ngọc Hà', province: 'Hà Nội'}
      // formatted_address: 273 Đội Cấn, Ngọc Hà, Ba Đình, Hà Nội
      // name: 273 Đội Cấn
      setMarkPosition({
        longitude: e.result.result.geometry.location.lng,
        latitude: e.result.result.geometry.location.lat,
      })
      setInputValue(e.result.result.name)
      handleGetAddress(e.result.result)
    }
  }

  return (
  <>
    <MapGL
        ref={mapRef}
        {...viewPort}
        width="100%"
        height="100%"
        onViewportChange={handleViewportChange}
        goongApiAccessToken='oTxfP4OrOb8P86btTxhjcFJvVCoMlYawdzFfODoR'
        >
        <Geocoder
          mapRef={mapRef}
          onViewportChange={handleGeocoderViewportChange}
          goongApiAccessToken='BcdF53tk2B4TWJLvlAEOMgXn1TCGofgOpQ96Sqqf'
          onResult={handleGetResult}
          inputValue={inputValue}
        />
        <CustomMarker longitude={markPosition.longitude} latitude={markPosition.latitude} />
      </MapGL>
  </>
  )
}

export {MapCustom}
